import { gate } from 'hub-http/gates';
export const GATES = {
  CHIRP_MIGRATION: gate('ProductApprovals::FE::ChirpMigration'),
  USER_SENT_REMINDER_NOTIFICATION: gate('ProductApprovals:UserSentReminderNotification'),
  ALLOW_APPROVERS_TO_CANCEL: gate('ProductApprovals::AllowApproversToCancel'),
  EDIT_APPROVAL_TITLE: gate('ProductApprovals::Platform::EditTitle')
};